import { IExpression } from '../IExpression';
import { ExpressionRepository } from '../repository/ExpressionsRepository';
import { EvaluationScope, IEvaluationScope } from './EvaluationScope';
import { ExpressionValue } from './ExpressionValue';

/**
 * Valuta un'espressione, sostituendo i riferimenti con i valori corrispondenti
 * e calcolando il risultato finale.
 *
 * @param expression Espressione da valutare
 * @param scopeData Contesto di valutazione, con le variabili disponibili per la sostituzione
 * @returns L'espressione valutata
 */
export function evaluateExpression(
  expression: IExpression,
  scopeData: IEvaluationScope,
): ExpressionValue {
  const scope = new EvaluationScope(scopeData, evaluateExpressionWithScope);
  return scope.evaluate(expression);
}

function evaluateExpressionWithScope(
  expression: IExpression,
  scope: EvaluationScope,
) {
  const expressionType = ExpressionRepository.get(expression.type);
  if (!expressionType) {
    console.error(`Expression type not found`, { expression, scope });
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(`L'espressione contenuta nella regola non è valida.`);
    }

    // In produzione, evitiamo di interrompere l'esecuzione ma restituiamo
    // un valore nullo.
    return null;
  }
  return expressionType.evaluate(expression, scope);
}
